<div class="loading">
  <img src="/assets/images/loading.svg" alt="loading">
</div>